import { truncateText } from "../../utils/textTruncateUtils";

const FileRow = ({ icon, name, user, modified, extension, size, actions, onClick }) => (
  <tr
    style={{ cursor: onClick ? "pointer" : "default" }}
    onDoubleClick={onClick}
    className="fnt14"
  >
    <td className="ps-4">
      <div className="d-flex align-items-center gap-3">
        {/* <input type="checkbox" /> */}
        {icon}
        <span title={name}>{truncateText(name, 40)}</span>
      </div>
    </td>
    <td className="small" title={user}>{truncateText(user, 20) || "--"}</td>
    <td className="small" title={extension}>{truncateText(extension, 30) || "--"}</td>
    <td className="small">{size || "--"}</td>
    <td className="small">{modified || "--"}</td>
    <td>
      <div className="d-flex gap-2">{actions}</div>
    </td>
  </tr>
);

export default FileRow;
